import { lazy, Suspense } from "react";
import { cn } from "@util/helpers";

type XEmbedCustomProps = {
  /** Optional className for the embed container */
  className?: string;
  /** The URL of the X embed */
  url: string;
};

const Tweet = lazy(() =>
  import("react-tweet").then((module) => ({ default: module.Tweet }))
);

const XEmbedCustom = ({
  className,
  url,
}: XEmbedCustomProps): React.ReactElement => {
  const tweetId = url.split("/").pop();

  if (!tweetId) return <></>;

  return (
    <Suspense>
      <div
        className={cn(
          "mb-6 flex justify-center [&>div]:w-full [&>div]:max-w-[550px]",
          className
        )}
        data-testid="x-embed-custom-component"
      >
        <Tweet id={tweetId} />
      </div>
    </Suspense>
  );
};

export default XEmbedCustom;
